import React,{useState,useEffect,useRef} from 'react'
import Card from './Card'
import { modalToggle } from '../../redux/actions/general'
import { useDispatch,useSelector } from 'react-redux'
import LoadingCard from '../LoadingCard'
import SearchRed from 'assets/icon/search-red.png'
import Chevron from 'assets/icon/chevron.png'
import { getBeranda,getForumDetailBySlug,getForumList,postForumAction,deleteDiskusi } from 'redux/actions/forum'
import { setPersist } from 'redux/actions/persist'
import { setReducer,setForumList } from 'redux/actions/reducer'
import detectBottom from 'service/detectBottom'
import EmptyBeranda from 'assets/image/empty-beranda.png'
export default function Beranda() {
    const dispatch = useDispatch()
    const general = useSelector(state => state.general)
    const reducer = useSelector(state => state.reducer)
    const persist = useSelector(state => state.persist)
    const [sort, setsort] = useState('terbaru')
    const [page, setpage] = useState(1)
    const [perpage, setperpage] = useState(5)
    const [stop, setstop] = useState(false)
    const [option, setoption] = useState({})
    const [opencomment, setopencomment] = useState({})
    const ref = useRef()
    const isVisible = detectBottom(ref)
    const {beranda,forum_list,forum_detail}=reducer
    const {forum_sort,forum_auth}=persist
    // console.log(`forum_auth`, forum_auth)
    useEffect(() => {
        if(beranda===null){
            getAsyncBeranda()
        }
        if(isVisible&&!stop){
            setpage(page+1)
            getAsyncForum()
        }
    }, [isVisible])
    const getAsyncBeranda=async ()=>{
        let res=await dispatch(getBeranda(`/${persist.forum_id}/${forum_sort}/${page}/${perpage}`))
        if(res){
            setpage(page+1)
            if(res.data.items.length>0){
                setstop(false)
            }else{
                setstop(true)
            }
        }
    }
    const getAsyncForum=async ()=>{
        
        let res=await dispatch(getForumList(`/${persist.forum_id}/${forum_sort}/${page}/${perpage}`))
        if(res){
            if(res.data.items.length>0){
                setstop(false)
            }else{
                setstop(true)
            }
        }
        
    }
    const sortToggle=(key)=>{
        dispatch(setPersist({forum_sort:key}))   
        setpage(1)
        dispatch(getBeranda(`/${persist.forum_id}/${key}/1/${perpage}`))
    }
    const addDiskusi=()=>{
        if(forum_auth.canPost){
            dispatch(modalToggle({ 
                modal_open: true,
                modal_title: "Buat Diskusi",
                modal_component: "add_diskusi",
                modal_size:590,
                modal_type:'',
                modal_data:{getAction:()=>dispatch(getBeranda(`/${persist.forum_id}/${forum_sort}/${1}/${perpage}`))},
                modal_action:'add_diskusi',
            }))
        }
        
    }
    const addFilter=()=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "",
            modal_component: "filter",
            modal_size:590,
            modal_type:'',
            modal_data:null,
            modal_action:'filter',
        }))
    }
    const addSortir=()=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "Sortir",
            modal_component: "sortir",
            modal_size:590,
            modal_type:'',
            modal_data:{actionSort:(key)=>sortToggle(key)},
            modal_action:'sortir',
        }))
    }
    const showSearch=()=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "Cari berdasarkan tag",
            modal_component: "search",
            modal_size:590,
            modal_type:'',
            modal_data:null,
            modal_action:'search',
        }))
    }
    const renderSort=()=>{
        switch (forum_sort) {
            case 1:
                return 'Terbaru'
            case 2:
                return 'Termenarik'
            case 3:
                return 'Terjawab'
            case 4:
                return 'Belum Terjawab'
                
        
            default:
                break;
        }
    }
    const onClickVote=(data,i)=>{
        if(forum_auth.canVote){
            forum_list[i].nvote=forum_list[i].isVoted===false?forum_list[i].nvote+1:forum_list[i].nvote
            forum_list[i].isVoted=true
            dispatch(setReducer({forum_list:forum_list}))
            dispatch(postForumAction(`/vote/${data.id}`))
        }
        
    }
    const flagAction=(data,i)=>{
        forum_list[i].nflag=forum_list[i].nflag+1
        forum_list[i].isFlag=true
        dispatch(setReducer({forum_list:forum_list}))
        dispatch(postForumAction(`/flag/${data.id}`))
        return data
    }
    const onClickFlag=(data,i)=>{
        if(forum_auth.canFlag){
            dispatch(modalToggle({ 
                modal_open: true,
                modal_title: "",
                modal_component: "delete_diskusi",
                modal_size:400,
                modal_type:'delete',
                modal_data:{
                    actionDelete:()=>flagAction(data,i),
                    getAction:()=>null,
                    data,
                    title:' Laporkan Postingan Ini',
                    desc:'Postingan ini mengandung unsur yang tidak relevan dengan forum diskusi, laporkan postingan ini untuk ditinjau oleh tim kami dan akan dihapus jika memang merupakan postingan yang tidak relevan.',
                    btn_delete:'Laporkan'
                },
                modal_action:'delete_diskusi',
            }))
            
        }
        
    }
    const optionToggle=(data,i)=>{
        setoption({...option,[i]:!option[i]})
    }

    const editDiskusi=(data,i)=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "Edit Diskusi",
            modal_component: "add_diskusi",
            modal_size:590,
            modal_type:'',
            modal_data:{getAction:()=>dispatch(getBeranda(`/${persist.forum_id}/${forum_sort}/${1}/${perpage}`)),data},
            modal_action:'edit_diskusi',
        }))
    }
    const onDeleteDiskusi=(data,i)=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "",
            modal_component: "delete_diskusi",
            modal_size:400,
            modal_type:'delete',
            modal_data:{
                actionDelete:()=>dispatch(deleteDiskusi(data.id)),
                getAction:()=>dispatch(getBeranda(`/${persist.forum_id}/${forum_sort}/${1}/${perpage}`)),
                data,
                title:' Hapus Postingan Diskusi',
                desc:'Postingan diskusi mu akan di hapus dari sistem',
                btn_delete:'Hapus Postingan'
            },
            modal_action:'delete_diskusi',
        }))
    }
    const openCommentToggle=async (data,i)=>{
        // setopencomment({...opencomment,[i]:!opencomment[i]})
        setopencomment({[i]:!opencomment[i]})
        await dispatch(getForumDetailBySlug(`/${1}/${1}/${50}/${data.slug}`))

    }
    return (
        <div>
            <div className='fix-menu-beranda'>

                <div className='menu-beranda-desktop'>
                    <div className='div-flex div-justify-between div-align-center'>
                        <h4 className='font-roboto margin-0'>{beranda!==null&&beranda.forumName!=='Home'&&'Diskusi mengenai'}  {beranda!==null&&beranda.forumName!=='Home'?beranda.forumName:''} </h4>
                        {forum_auth.canPost&&<button onClick={addDiskusi} className='btn-forum'>Buat Diskusi</button>}
                    </div>
                    <div className='beranda-info div-flex div-justify-between div-align-center'>
                        <p className='font-nunito amount-diskusi margin-0'>{beranda!==null&&beranda.info.total} Diskusi</p>
                        <div className='beranda-sort'>
                            <div className={`beranda-sort-item ${forum_sort===1&&'beranda-sort-active'}`} onClick={()=>sortToggle(1)}>
                                <p className='font-nunito margin-0'>Terbaru</p>
                            </div>
                            <div className={`beranda-sort-item ${forum_sort===2&&'beranda-sort-active'}`} onClick={()=>sortToggle(2)}>
                                <p className='font-nunito margin-0'>Termenarik</p>
                            </div>
                            <div className={`beranda-sort-item ${forum_sort===3&&'beranda-sort-active'}`} onClick={()=>sortToggle(3)}>
                                <p className='font-nunito margin-0'>Terjawab <span>{beranda!==null&&beranda.countTerjawab!==0&&`(${beranda.countTerjawab})`}</span></p>
                            </div>
                            <div className={`beranda-sort-item ${forum_sort===4&&'beranda-sort-active'}`} onClick={()=>sortToggle(4)}>
                                <p className='font-nunito margin-0'>Belum Terjawab <span>{beranda!==null&&beranda.countBelumTerjawab!==0&&`(${beranda.countBelumTerjawab})`}</span></p>
                            </div>
                        </div>
                    </div>
                    <div className='beranda-hr'></div>
                </div>
                <div className='menu-beranda-mobile'>
                    <div className='div-flex div-justify-between beranda-mobile-head'>
                        {beranda!==null&&beranda.forumName!=='Home'&&<h4 className='font-roboto margin-0'>Diskusi {beranda.forumName}</h4>}
                        {forum_auth.canPost&&<button onClick={addDiskusi} className='btn-forum'>Buat Diskusi</button>}

                    </div>
                    <div className='div-flex div-justify-between beranda-mobile-info'>
                        <div className='div-flex div-align-center'>
                            <p className='font-nunito margin-0'>Sortir : {renderSort()}</p>
                            &nbsp;&nbsp;&nbsp;
                            <img onClick={addSortir} src={Chevron} className='chevron-mobile-sort'/>
                        </div>
                        <div className='div-flex div-align-center'>
                            <img onClick={showSearch} src={SearchRed} className='search-mobile'/>
                            &nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;
                            <p onClick={addFilter} className='font-roboto margin-0 font-bold' style={{color:'#ff4e4e'}}>Forum</p>
                        </div>
                    </div>
                    <div className='beranda-hr'></div>

                </div>
                
            </div>
            <div className='card-container'>
                
            {/* {general.isLoadingBeranda&&
                <>
                    <LoadingCard/>
                    <LoadingCard/>
                </>
                } */}
                {forum_list.map((data,i)=>(
                    <Card 
                        data={data} 
                        key={i}
                        index={i}
                        onClickVote={onClickVote}
                        onClickFlag={onClickFlag}
                        forum_auth={forum_auth}
                        optionToggle={optionToggle}
                        option={option}
                        editDiskusi={editDiskusi}
                        deleteDiskusi={onDeleteDiskusi}
                        opencomment={opencomment}
                        openCommentToggle={openCommentToggle}
                    />
                ))}
                {!general.isLoadingBeranda&&forum_list.length<1&&
                <div style={{textAlign:'center',height:500}}>
                    <img src={EmptyBeranda} className='empty-beranda'/>
                    <h2 className='font-roboto'>Belum ada diskusi {forum_auth.canPost&&<>,ayo <span onClick={addDiskusi} style={{color:'#ff4e4e',cursor:'pointer'}}>Buat Diskusi</span></>}</h2>
                </div>
                }
                
                {general.isLoadingBeranda&&
                <>
                    <LoadingCard/>
                    {/* <LoadingCard/> */}
                </>
                }
                <div ref={ref}></div>

            </div>
        </div>
    )
}
